import { Paper } from "@mui/material";
import { useProfile } from "../../common/useProfile";
import { config } from "../../config";

export function CurrentUser() {
  const profile = useProfile();

  return (
    <Paper sx={{ px: 3, py: 1 }}>
      <h2>Build info:</h2>
      <pre>
        Build timestamp: {import.meta.env.VITE_REACT_APP_BUILD_TS || "Unknown"}
        <br />
        Version: {import.meta.env.VITE_REACT_APP_VERSION || "Unknown"}
        <br />
        API: {config.apiBase || "Unknown"}
        <br />
        WS: {config.wsAddress || "Unknown"}
        <br />
        OIDC: {config.authServer || "Unknown"}
      </pre>
      <h2>User data:</h2>
      <pre>{JSON.stringify(profile, undefined, 2)}</pre>
    </Paper>
  );
}
